import { FC } from "react";
import NumberInputBase from "../../../../assets/components/Inputs/NumberInput/NumberInputBase";
import "./ActivationLimitEditor.scss";

interface ActivationLimitEditorProps {
    value: number;
    currentCount: number;
    maxLimit: number;
    error?: string;
    onChange: (value: number, error: string | null, dirty: boolean) => void;
}

export const ActivationLimitEditor: FC<ActivationLimitEditorProps> = ({
    value,
    currentCount,
    maxLimit,
    error,
    onChange,
}) => {
    const validate = (newValue: number): string | null => {
        if (newValue < currentCount) {
            return `Minimum is ${currentCount}`;
        }
        if (newValue > maxLimit) {
            return `Maximum allowed is ${maxLimit}`;
        }
        return null;
    };

    const handleChange = (newValue: number) => {
        const validationError = validate(newValue);
        const dirty = newValue !== currentCount;

        onChange(newValue, validationError, dirty);
    };

    return (
        <div className="activation-limit-editor">
            <NumberInputBase
                value={value}
                min={currentCount}
                max={maxLimit}
                disabled={false}
                error={error || ""}
                onChange={handleChange}
            />
        </div>
    );
};
